// extracted by mini-css-extract-plugin
export default {"modalOverlay":"OD-z","modalContent":"PD-z","header":"QD-z","close":"RD-z"};